module.exports = __webpack_public_path__ + "img/benitier-normal-h900.78ce3cf6.jpg";